import { useTechStore } from "@/Store/TechStore";
import { useProjectStore } from "@/Store/ProjectStore";
var Actions = {
  actions: {
    onGlobalStateChange: null,
    setGlobalState: null,
  },
  setActions(actions) {
    this.actions = actions;

    this.actions.onGlobalStateChange((state, prev) => {
      console.log("子项目", state, prev);
      const techStore = useTechStore();
      techStore.changeUserInfo(state.TechStore.userInfo);
      // 这里监听母项目的状态改变，从而改变子项目的状态
      const projectStore = useProjectStore();
      projectStore.changeCurrentProject(state.AppStore.nowtakoprojectapp);


      // store.commit('CHANGE_NOWPROJECTAPP', state.AppStore.nowprojectapp);
      // store.commit('CHANGE_NOWPROJECTAPP', state.AppStore.nowprojectapp);
      // store.commit('CHANGE_NOWPROJECTAPPNAME', state.AppStore.nowProjectAppName);
      // store.commit('CHANGE_NOWPROJECTSHORTNAME', state.AppStore.nowProjectShortName);
      // store.commit('SAVE_PROJECTLIST', state.AppStore.storeprojectlist);
    });
  },

  /**
   * 映射
   */
  setGlobalState(...args) {
    if (this.actions.setGlobalState != null) {
      return this.actions.setGlobalState(...args);
    }
  },
};

export default Actions;
